import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import "../../css/Common/commonpopup.css";

export default function CommonPopUp({
    visible,
    onHide,
    onConfirm,
    loading = false,
}) {
    return (
        <Dialog
            visible={visible}
            onHide={onHide}
            modal
            draggable={false}
            showHeader={false}
            closable={false}
            className="confirm-dialog"
            maskClassName="logout-modal-mask"
        >
            <div className="confirm-card">
                <h2 className="confirm-title">
                    Are you sure, <br />
                    you want to logout?
                </h2>

                <div className="confirm-actions">
                    <Button
                        label="Cancel"
                        className="confirm-cancel"
                        onClick={onHide}
                        disabled={loading}
                    />
                    <Button
                        label="Logout"
                        className="confirm-primary"
                        onClick={onConfirm}
                        loading={loading}
                    />
                </div>
            </div>
        </Dialog>
    );
}
